import React from "react";
import { CustomModal } from "./styles";
import { groupBy, keyBy, mapValues } from "lodash";
import {
  Container,
  Header,
  Title,
  Subtitle,
  Section,
  SectionTitle,
  Table,
} from "./ExhibitLayout";

const numberWithCommas = n =>
  n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

// The business-case scoped endpoint pre-filters `features` to the
// requested round and drops `round_number` from each row, so there's
// no per-row filter to apply on the FE anymore.
const getData = (features) => {
  return mapValues(
    groupBy(features, "rank"),
    i => mapValues(keyBy(i, "type"), i => numberWithCommas(i.rnd_costs.toFixed(0)))
  );
};

const ModalExhibit2 = ({ features, goBack }) => {
  const data = getData(features);
  return (
    <CustomModal goBack={goBack}>
      <Container>
        <Header>
          <Title>Exhibit 2: Estimated R&D Costs</Title>
          <Subtitle>R&D cost per feature type, broken out by rank.</Subtitle>
        </Header>

        <Section>
          <SectionTitle>Cost by Feature</SectionTitle>
          <Table>
            <thead>
              <tr>
                <th>Quality Rank</th>
                <th>Resolution</th>
                <th>Sensitivity</th>
                <th>Power</th>
                <th>Temperature</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(data).map(rank => {
                const feature = data[rank];
                return (
                  <tr key={rank}>
                    <td><b>{rank}</b></td>
                    <td className="numeric">${feature["Pixels"]}</td>
                    <td className="numeric">${feature["Sensitivity"]}</td>
                    <td className="numeric">${feature["Power"]}</td>
                    <td className="numeric">${feature["Temperature Range"]}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </Section>
      </Container>
    </CustomModal>
  );
};

export default ModalExhibit2;



// WEBPACK FOOTER //
// ./src/components/bcase/ModalExhibit2.js